import { render, staticRenderFns } from "./code-input.vue?vue&type=template&id=0a4f39f2&"
import script from "./code-input.vue?vue&type=script&lang=js&"
export * from "./code-input.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports